module.exports = __webpack_public_path__ + "static/img/design_button.9d7dedec.png";